import React from 'react';
import { Subtitle2 } from '../../../../Style/DesignSystem/Typography';
import { ManifestBundleHeader as Main, BundleHeaderBody } from '../../../../Style/Manifest';

export const ManifestBundleHeader = ({
    title,
    bundleShortName
}) => {
    return (
        <Main className={`${bundleShortName}-bundle-header`}>
            <BundleHeaderBody>
                <Subtitle2 className="no-margin">{title}</Subtitle2>
            </BundleHeaderBody>
        </Main>
    )
}